export enum OfficeExclusiveType {
  NONE = 'None',
  OFFICE_EXCLUSIVE = 'Office Exclusive Document',
}

export const OFFICE_EXCLUSIVE_SHORT_DESC = 'Office Exclusive Document';

export const OFFICE_EXCLUSIVE_FILENAME = 'Office Exclusive Agreement.pdf';

export const OFFICE_EXCLUSIVE_KEY = 'OFFICE_EXCLUSIVE_DOCUMENT';

export const RETRY_AFTER_INVALID_FILES = true;
